import React                    from 'react';
import { Observe }              from 'rewire-core';
import { WithStyle }            from 'rewire-ui';
import { withStyles }           from '../utility/styles';
import { Theme }                from '@material-ui/core/styles';
import Button                   from '@material-ui/core/Button';
import Link                     from '@material-ui/core/Link';
import Typography               from '@material-ui/core/Typography';
import FilterListIcon           from '@material-ui/icons/FilterListOutlined';
import PrioritySortMenu         from '../ui/PrioritySortMenu';
import AuditLogFilterDialog     from './AuditLogFilterDialog';
import auditLogListModel        from './AuditLogListModel';

const styles = (_theme: Theme) => ({
  root: {
    zIndex: 10,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
  },
  buttons: {
    display: 'flex',
    flex: '0 0 auto',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    marginBottom: '7px',
  },
  button: {
    minWidth: '0px',
    minHeight: '0px',
    padding: '0px',
    marginLeft: '15px',
    '&:first-child': {
      marginLeft: '0px',
    },
  },
  removeFiltersContainer: {
    marginBottom: '3px',
  },
  removeFiltersButton: {
    cursor: 'pointer',
  },
});

export interface IAuditLogDialogProps {
  classes: any;
}

export type AuditLogToolbarProps = WithStyle<ReturnType<typeof styles>, IAuditLogDialogProps>;

class AuditLogToolbar extends React.PureComponent<AuditLogToolbarProps> {
  constructor(props: AuditLogToolbarProps) {
    super(props);
  }

  clearFilters = () => {
    auditLogListModel.clearFilters();
  };

  showFilterDialog = () => {
    auditLogListModel.showFilterDialog();
  };

  render() {
    const { classes } = this.props;

    return <Observe render={() => (
      <div className={classes.root}>
        <Observe render={() => (
          auditLogListModel.hasFilters &&
            <div className={classes.removeFiltersContainer}>
              <Typography variant='caption'><Link onClick={this.clearFilters} className={classes.removeFiltersButton} variant='caption' underline='always'>Clear Filters</Link></Typography>
            </div>
        )} />
        <div className={classes.buttons}>
          <Button title='Filter By' className={classes.button} onClick={this.showFilterDialog}><FilterListIcon /></Button>
          <PrioritySortMenu model={auditLogListModel.sortModel} classes={{menuButton: classes.button}} />
          <AuditLogFilterDialog />
        </div>
      </div>
    )} />;
  }
}

export default withStyles<IAuditLogDialogProps>(styles, AuditLogToolbar);
